var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 49,
    viewBox: "0 0 68 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3584 1.89047C62.838 -0.630158 58.7516 -0.630158 56.2311 1.89047L24.6776 33.4467L11.0176 19.7855C8.49713 17.2649 4.41073 17.2649 1.89031 19.7855C-0.630105 22.3061 -0.630105 26.3929 1.89031 28.9135L20.0849 47.1096C21.3548 48.3797 23.0223 49.0098 24.6868 49C26.3451 49.0051 28.0051 48.3749 29.2704 47.1095L65.3584 11.0185C67.8788 8.49786 67.8788 4.41111 65.3584 1.89047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrue);
export default __webpack_public_path__ + "static/media/True.170abd026b2abd121619c1e906c73e3a.svg";
export { ForwardRef as ReactComponent };